import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import {
  IBillingDocument,
  IBillingAccount,
  IBillingBalance,
} from '@dch/billing-business-logic';
import { OnDestroyHookDirective } from '../common/hooks';
import {
  ODB_DETAILS_SESSION_DATA_KEY,
  UtilsService,
} from '../services/utils.service';
import { SelectedOdbDetailsInfo } from '../models/pii.model';
import { Customer, CustomerAccount } from '@dch/common-business-logic';
import { InceptionService } from '@dch/ng-common';
import { Router } from '@angular/router';
import { ApplicationState } from 'src/app/state/reducers';
import {
  selectCustomerAccount,
  selectCustomer,
} from 'src/app/state/selectors/customer-account.selector';

import { OVERVIEW_PAGE } from '../config/my-bill.constants';
import { TransactionReferenceService } from '../services/transaction-reference.service';

@Component({
  selector: 'my-bill-cover-no-details-page',
  templateUrl: './cover-no-details-page.component.html',
  standalone: false,
})
export class CoverNoDetailsPageComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  constructor(
    private utilsService: UtilsService,
    private router: Router,
    private inceptionService: InceptionService,
    private store: Store<ApplicationState>,
    private transactionReferenceService: TransactionReferenceService
  ) {
    super();
  }

  selectedCustomer: Customer;
  customerAccount: CustomerAccount;
  selectedOdbDetailsInfo?: SelectedOdbDetailsInfo;
  billDocument?: IBillingDocument;
  billingAccount?: IBillingAccount;
  openTransactionToPayIndex?: number;
  isResUser: boolean;
  customerPaymentProfile?: IBillingBalance['customerPaymentProfile'];
  headerTitle = 'bills.cover.odbDetails.screenTitle';

  readonly selectedCustomerAccount$ = this.store.select(selectCustomerAccount);
  readonly selectedCustomer$ = this.store.select(selectCustomer);

  ngOnInit() {
    this.selectedOdbDetailsInfo =
      this.utilsService.getInfoFromSessionStorage<SelectedOdbDetailsInfo>(
        ODB_DETAILS_SESSION_DATA_KEY
      );
    const billDocument = this.selectedOdbDetailsInfo?.billDocument;

    if (
      this.selectedOdbDetailsInfo !== undefined &&
      billDocument !== undefined
    ) {
      const {
        billingAccount,
        openTransactionToPayIndex,
        customerPaymentProfile,
      } = this.selectedOdbDetailsInfo;

      this.billDocument = billDocument;
      this.billingAccount = billingAccount;
      this.openTransactionToPayIndex = openTransactionToPayIndex;
      this.customerPaymentProfile = customerPaymentProfile;
      this.fetchCoverPageData();
      this.fetchTransactionReferencesIfNeeded();
      this.scrollToTop();
    } else {
      this.router.navigate([OVERVIEW_PAGE]);
    }
  }

  private fetchCoverPageData() {
    this.addSubscription(
      combineLatest([this.selectedCustomer$, this.selectedCustomerAccount$])
        .pipe(
          filter(
            ([selectedCustomer, selectedCustomerAccount]) =>
              selectedCustomerAccount !== undefined &&
              selectedCustomer !== undefined
          ),
          tap(([selectedCustomer, selectedCustomerAccount]) => {
            this.selectedCustomer = selectedCustomer;
            this.customerAccount = selectedCustomerAccount;
            this.isResUser =
              this.customerAccount.getSelectedCustomer().subsegment === 'RES';
            const resKey = this.isResUser ? 'RES.' : '';
            this.headerTitle = `bills.cover.odbDetails.${resKey}screenTitle`;
          })
        )
        .subscribe()
    );
  }

  private fetchTransactionReferencesIfNeeded() {
    if (
      this.selectedCustomer.subsegment !== 'RES' &&
      this.utilsService.isPeppolUBLXmlApiAvailable()
    ) {
      this.transactionReferenceService
        .isTransactionReferencesLoaded(this.billingAccount?.accountNumber)
        .pipe(
          tap((source) => {
            if (source === undefined) {
              this.transactionReferenceService.fetchTransactionReferences(
                this.billingAccount?.accountNumber
              );
            }
          })
        )
        .subscribe();
    }
  }

  private scrollToTop(): void {
    setTimeout(() => this.inceptionService.scrollToElement('#maincontent'));
  }
}
